export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0 w-full max-w-xs md:max-w-sm aspect-[4/3] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20warm%20ambient%20lighting%2C%20open%20book%20on%20wooden%20table%2C%20soft%20cushions%2C%20warm%20golden%20hour%20sunlight%20streaming%20through%20window%2C%20peaceful%20atmosphere%2C%20artistic%20lifestyle%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=800&height=600&seq=about-platform&orientation=landscape"
              alt="腐漫画网平台介绍 - 温馨阅读场景"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              关于腐漫画网
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              腐漫画网诞生于对腐漫文化的热爱与坚持，我们致力于为广大腐漫爱好者提供一个纯净、便捷、内容丰富的在线阅读平台。无论是韩漫腐的细腻情感刻画、韩漫耽美的唯美画风、日漫腐的经典叙事，还是国漫耽美的本土原创魅力，这里都能找到属于你的那一部心动之作。平台坚持每日更新，覆盖完结全集与新番连载，下拉式阅读设计让你告别翻页烦恼，沉浸式享受每一页精彩。我们严格筛选内容质量，杜绝恶意广告与弹窗，只为守护你纯粹的阅读时光。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-check-double-line text-accent-500"></i> 人工精选内容</span>
              <span className="flex items-center gap-1"><i className="ri-check-double-line text-accent-500"></i> 全本免费阅读</span>
              <span className="flex items-center gap-1"><i className="ri-check-double-line text-accent-500"></i> 持续每日更新</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}